import { Pricing } from "@/pages/settings/pages/products-v2/types";
import {
  ContractRevenueItem,
  EqPaymentsBillingFrequency
} from "@/pages/contracts/types";

export type DiscountType = "percentage" | "amount";

export enum RevenueItemColumn {
  SERVICE = "serviceItemName",
  STATUS = "status",
  PERIOD = "customServiceDuration",
  QUANTITY = "quantity",
  PRICING = "price",
  BILLING = "customBillingFrequency",
  DISCOUNT = "discountAmount",
  TOTAL = "total",
  NOTE = "note"
}

export enum RevenueItemStatus {
  ACTIVE = 1,
  UPCOMING = 2,
  EXPIRED = 3,
  ONE_TIME = 4,
  DRAFT = 5
}

export interface ContractServiceData {
  serviceId: string;
  serviceName: string;
  selectedPricing: Pricing | null;
  quantity: number;
  discount: number;
  billingStartDate: string;
  total: number;
}

export type PaymentType = "equal" | "scheduled";

// A row of the scheduled-payments table while the drawer is open. `id` is a
// client-side key only — the persisted row carries its own backend id.
export interface ScheduledPaymentDraft {
  id: string;
  billingDate: string;
  amount: number;
  percentage: number;
}

export interface SplitPaymentData {
  numberOfPayments: number;
  billingFrequencyLabel: string;
  billingFrequency: EqPaymentsBillingFrequency;
  billingEvery?: number;
}

export interface PricingOption {
  id: string;
  displayName: string;
  subtitle?: string;
}

export interface Contract {
  id: string;
  name: string;
  dealId: string;
  currency: string;
  revenueItems: ContractRevenueItem[];
  total: number;
}
